
const m = window.require("@fortawesome/fontawesome-svg-core");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;
